import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Field, Form, FormSpy } from 'react-final-form';
import Typography from '../modules/components/Typography';
import AppFooter from '../modules/views/AppFooter';
import AppAppBar from '../modules/views/AppAppBar';
import AppForm from '../modules/views/AppForm';
import { email, password, required } from '../modules/form/validation';
import RFTextField from '../modules/form/RFTextField.js';
import FormButton from '../modules/form/FormButton';
import FormFeedback from '../modules/form/FormFeedback';
import { useLocation, useNavigate } from 'react-router-dom';
import { userSignUp, getUserCurrentlyAuthenticated } from '../modules/components/authentication';
import { FORM_ERROR } from 'final-form';
import PasswordRFTextField from '../modules/components/PasswordRFTextField';
import logger
 from '../modules/components/logger';
function SignUp() {
  const {state} = useLocation();
  const initialValueEmail = state?.userEmail;

  const navigate = useNavigate();

  const [userEmail, setUserEmail] = React.useState(initialValueEmail || "");

  const handleClickSignIn = () => {
    navigate('/sign-in', { state: { userEmail } })
  }

  React.useEffect(() => {
    getUserCurrentlyAuthenticated()
      .then(() => navigate("/dashboard"))
      .catch(logger.info);
      // eslint-disable-next-line
  }, [navigate]);

  const [isValid, setIsValid] = React.useState(false);

  const validate = (values) => {
    const errors = required(['email', 'password'], values);

    if (!errors.email) {
      const emailError = email(values.email);
      if (emailError) {
        errors.email = emailError;
      }
    }

    if (!errors.password) {
      const passwordError = password(values.password);
      if (passwordError) {
        errors.password = passwordError;
      }
    }

    setIsValid(Object.keys(errors).length === 0);

    return errors;
  };

  const handleSubmit = ({ email, password}) => {
    return userSignUp(email, password)
      .then((value) => {
        if (value.userConfirmed === false) {
          navigate('/verification', { state: { userEmail: email, userPassword: password } });
        }
      })
      .catch((reason) => {
        const exception = reason.code;
        logger.log(exception);
        let message = "Could not sign up.";
        if (exception === "UsernameExistsException")
          message = "User email already registered.";
        return {[FORM_ERROR]: message};
      });
  };

  return (
    <React.Fragment>
      <AppAppBar />
      <AppForm>
        <React.Fragment>
          <Typography variant="h3" gutterBottom marked="center" align="center">
            Sign Up
          </Typography>
          <Typography variant="body2" align="center">
            <Link  
              underline="always" 
              variant="body2" component="button" 
              onClick={handleClickSignIn}
              style={{paddingBottom: "2px"}}
            >
              Already have an account?
            </Link>
          </Typography>
        </React.Fragment>
        <Form
          onSubmit={handleSubmit}
          subscription={{ submitting: true, dirty: true }}
          validate={validate}
        >
          {({ handleSubmit: handleSubmit2, submitting, dirty }) => (
            <Box component="form" onSubmit={handleSubmit2} noValidate sx={{ mt: 6 }}>
              <Field
                autoFocus
                autoComplete="email"
                component={RFTextField}
                disabled={submitting}
                fullWidth
                label="Email"
                initialValue={initialValueEmail}
                margin="normal"
                name="email"
                required
                size="large"
                onInput={e => setUserEmail(e.target.value)}
              />
              <PasswordRFTextField
                name="password"
                label="Password"
                disabled={submitting}
                autoComplete="new-password"
                dirty={dirty}
              />
              <Typography variant="body2" align="justify" color="text.secondary" sx={{ mt: 2 }}>
                {`By signing up, you are agreeing to receive emails from Watch Exchanger about your account.
                Watch Exchanger will never share your email with any third parties. `}
                <Link href="/privacy" underline="always" color="text.secondary">
                  Learn more.
                </Link>
              </Typography>
              <FormSpy subscription={{ submitError: true }}>
                {({ submitError }) =>
                  submitError ? (
                    <FormFeedback error sx={{ mt: 2 }}>
                      {submitError}
                    </FormFeedback>
                  ) : null
                }
              </FormSpy>
              <FormButton
                sx={{ mt: 3, mb: 2 }}
                disabled={!isValid || submitting}
                color="secondary"
                fullWidth
                size="large"
              >
                {submitting ? 'In progress…' : 'Sign Up'}
              </FormButton>
            </Box>
          )}
        </Form>
      </AppForm>
      <AppFooter />
    </React.Fragment>
  );
}

export default SignUp;